import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFound: React.FC = () => {
  const { t } = useTranslation('landing');
  return (
    <main className="not-found-shell">
      <div className="not-found-card">
        <img src="/logos/nomadme_sourcing_trading_mark.png" className="not-found-logo" alt="nomadme" />
        <h1 className="not-found-code">404</h1>
        <p className="not-found-msg">{t('notFound.message')}</p>
        <p className="not-found-sub">{t('notFound.sub')}</p>
        <Link to="/" className="not-found-btn">{t('notFound.backHome')}</Link>
      </div>
    </main>
  );
};

export default NotFound;
